import { amount } from "./api";
import { floorLabel, roomSummary, scopeCounters, type SummaryGroup } from "./roomSummary";

export function ScopeCounters({ groups }: { groups: SummaryGroup[] }) {
  const counters = scopeCounters(groups);
  if (!counters.length) return null;
  return <p className="muted summary-counters">{counters.map(c =>
    `${[c.building || "Здание не указано", c.discipline].join(" / ")}: работ ${c.works}` +
    (c.unknown ? `, объём не установлен — ${c.unknown}` : "") +
    (c.withoutRooms ? `, без расшифровки по помещениям — ${c.withoutRooms}` : "")).join(" · ")}</p>;
}

export function RoomSummaryView({ groups, pick }: { groups: SummaryGroup[]; pick: (id: string) => void }) {
  const rooms = roomSummary(groups);
  if (!rooms.length) return <p className="muted">Расшифровка по помещениям для выбранных работ ещё не установлена.</p>;
  return <>
    {rooms.map(room => <section key={[room.building, room.floor, room.place].join("|")}>
      <h3>{[room.building || "Здание не указано", floorLabel(room.floor) || "этаж не указан", `помещение ${room.place}`].join(" / ")}</h3>
      <table><thead><tr><th>Раздел / подраздел / тип</th><th>Вид работы</th><th>Вклад помещения</th></tr></thead><tbody>
        {room.operations.map((op, index) => <tr key={index}>
          <td>{[op.discipline, op.category, op.group].filter(Boolean).join(" / ")}</td>
          <td><button className="quiet" onClick={() => pick(op.workId)}>{op.description}</button><small>{op.mount}</small></td>
          <td>{op.value == null ? "вклад не установлен" : `${amount(op.value)} ${op.unit}`}</td>
        </tr>)}
      </tbody></table>
    </section>)}
    <p className="muted">Виды работ и единицы в помещении не складываются: каждая операция показана отдельно, неизвестный вклад остаётся пустым.</p>
  </>;
}
